import Phaser from 'phaser';
import BaseAppState from '../../utils/statemachine/BaseAppState';
import GameSounds from '../../sound/GameSounds';
import LogicCore from '../../logic/LogicCore';
import Logger from 'js-logger';
import GameOverScreen from '../../display/GameOverScreen';

const GameOverState = Object.assign( Object.create(BaseAppState), {
    setup: function(game) {
        this.init(game, 'GameOverState');

        this.onSignalGameOverExit = new Phaser.Signal();
        this.onSignalGameReady = new Phaser.Signal();
        this.onSignalNameEntered = new Phaser.Signal();
        this.onSignalViewLeaders = new Phaser.Signal();

        this.onSignalNameEntered.add(this.handleNameEntered, this);
        this.onSignalViewLeaders.add(this.handleViewLeaders, this);
        this.game.logic.onSignalInitialsSanitized.add(this.handleInitialsSanitized, this);

        return this;
    },

    onEnter: function() {
        this._onEnter(this);

        // when music loop finishes, play music end
        this.game.soundManager.playMusicEnd(GameSounds.MUSIC_END);
        this.game.soundManager.playSound(GameSounds.SOUND_GAME_OVER);

        // show any 'game over' messages, if any
        Logger.info('GAME OVER!', this.game);

        // check if score was in top N
        this.game.logic.fetchRank().then(this.handleRankRetrieved.bind(this));
    },

    update: function() {
        this._update();
    },

    onExit: function() {
        this._onExit();

        // hide the ticket
        this.gameOverScreen.hide().then(() => {
            this.game.stage.removeChild(this.gameOverScreen);

            this.gameOverScreen.destroy();
        });
    },

    handleRankRetrieved: function({rank}) {
        const {onSignalGameReady, onSignalGameOverExit, onSignalNameEntered, onSignalViewLeaders} = this;
        const options = {
            game: this.game,
            score: this.game.logic.score,
            isTopScore: rank <= LogicCore.LEADERS_TO_SHOW,
            stateSignals: {onSignalGameReady, onSignalGameOverExit, onSignalNameEntered, onSignalViewLeaders}
        };

        this.gameOverScreen = new GameOverScreen(this.game, options);
        this.game.stage.addChild(this.gameOverScreen);

        this.gameOverScreen.show();
    },

    handleNameEntered: function(name) {
        this.game.logic.submitPlayerInitials(name);
    },

    handleViewLeaders: function() {
        this.fetchAndShowLeaders();
    },

    handleInitialsSanitized: function() {
        this.fetchAndShowLeaders();
    },

    fetchAndShowLeaders: function() {
        this.game.logic.fetchLeaders().addOnce(leaderData => {
            this.gameOverScreen.showLeaders(leaderData);
        });
    }
});

export default GameOverState;



// WEBPACK FOOTER //
// ./app/src/states/game/GameOverState.js